import { useState, useEffect, useRef, useCallback } from 'react';
import { BaseFormModal } from '@/components/BaseFormModal';
import { focusAfterPaint } from '@/utils/dom';

export interface AddStatusUpdateOptionModalProps {
  open: boolean;
  theme?: string;
  saving?: boolean;
  editItem?: { id: number; name: string } | null;
  onSave: (data: { id?: number; name: string }) => void;
  onCancel: () => void;
}

export function AddStatusUpdateOptionModal({
  open,
  theme,
  saving = false,
  editItem = null,
  onSave,
  onCancel,
}: AddStatusUpdateOptionModalProps) {
  const [name, setName] = useState('');
  const inputRef = useRef<HTMLInputElement>(null);
  const isEditing = editItem != null;

  // Reset form and focus input when modal opens
  useEffect(() => {
    if (open) {
      setName(editItem?.name ?? '');
      focusAfterPaint(inputRef);
    }
  }, [open, editItem]);

  const handleSave = useCallback(() => {
    if (!name || !name.trim()) {
      (window as any).App?.showPopupNotification?.('Status Update Option name required.', 'error');
      return;
    }

    if (isEditing) {
      onSave({ id: editItem!.id, name: name.trim() });
    } else {
      onSave({ name: name.trim() });
    }
  }, [name, onSave, isEditing, editItem]);

  return (
    <BaseFormModal
      open={open}
      title={isEditing ? 'Edit Status Update Option' : 'Add Status Update Option'}
      theme={theme}
      dialogClass="kstc-dialog--form"
      saveText={saving ? 'Saving...' : isEditing ? 'Save' : 'Add'}
      saveDisabled={saving}
      busy={saving}
      onSave={handleSave}
      onCancel={onCancel}
    >
      <div className="kstc-form-group">
        <label className="kstc-label">Name</label>
        <input
          ref={inputRef}
          type="text"
          className="kstc-input"
          value={name}
          onChange={(e) => setName(e.target.value)}
          placeholder="Enter status update option..."
        />
      </div>
    </BaseFormModal>
  );
}
